import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { cn } from '@shared/lib';
import type { PasswordRules } from '../model/passwordRules';

interface PasswordRulesListProps {
  rules: PasswordRules;
  hasInput: boolean;
}

const RULE_KEYS: (keyof PasswordRules)[] = ['len', 'mix', 'num', 'sym'];

export function PasswordRulesList({ rules, hasInput }: PasswordRulesListProps) {
  const { t } = useTranslation();
  return (
    <div className="mt-2.5 grid grid-cols-1 gap-x-4 gap-y-1.5 sm:grid-cols-2">
      {RULE_KEYS.map((key) => {
        const ok = hasInput && rules[key];
        return (
          <div
            key={key}
            className={cn('flex items-center gap-2 text-xs transition-colors duration-200', ok ? 'text-fg' : 'text-muted')}
          >
            <motion.span
              initial={false}
              animate={{
                backgroundColor: ok ? '#3DD68C' : 'transparent',
                borderColor: ok ? '#3DD68C' : '#2a2a30',
              }}
              transition={{ duration: 0.2 }}
              className="inline-flex h-3.5 w-3.5 flex-shrink-0 items-center justify-center rounded border-[1.5px]"
            >
              <motion.span
                initial={false}
                animate={{ scale: ok ? 1 : 0, opacity: ok ? 1 : 0 }}
                transition={{ duration: 0.18, ease: 'backOut' }}
                className="text-[9px] font-bold leading-none text-fg-inv"
              >
                ✓
              </motion.span>
            </motion.span>
            <span>{t(`auth.reset.rules.${key}`)}</span>
          </div>
        );
      })}
    </div>
  );
}
